const getters = {
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  userId: (state) => state.user.id,
  name: (state) => state.user.name,
  userName: (state) => state.user.userName,
  user: (state) => state.user.user,
  orgId: (state) => state.user.orgId,
  orgName: (state) => state.user.orgName,
  updateFlag: (state) => state.user.updateFlag,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  sysInfo: (state) => state.user.sysInfo,
  tbId: (state) => state.user.tbId,
  // 是否已登出
  isOut: (state) => state.user.isOut,
  // 是否初次登录
  firstLogin: (state) => state.firstLogin,
  showChangePasswordDialog: (state) => state.user.showChangePasswordDialog,
};
export default getters;
